// extracted by mini-css-extract-plugin
export var adjacentSlide = "_l0-9";
export var arrowButtonContainer = "_l0-5";
export var arrowButtonIcon = "_l0-6";
export var carouselArrowButton = "_l0-2";
export var carouselElementContainer = "_l0-1";
export var currentSlide = "_l0-8";
export var left = "_l0-3";
export var otherSlide = "_l0-a";
export var productCarouselContainer = "_l0-0";
export var right = "_l0-4";
export var sliderOverflow = "_l0-7";